import {Route} from "react-router-dom";
import {lazy} from "react";
import UrlsConfig from "@/config/UrlsConfig";

const ReferenceBookNotificationLogs = lazy(() => import("@/pages/ReferenceBooks/Lists/NotificationLogs/ReferenceBookNotificationLogs"));

const urlsConfig = new UrlsConfig();

export function notificationLogsRoutes() {
    return <Route path={urlsConfig.referenceBookNotificationLogs.to} element={<ReferenceBookNotificationLogs/>}/>;
}
